// extracted by mini-css-extract-plugin
export default {"Buttons":"d_fx6cps","moneyViewButtonWrapper":"pBuQ_xHt","moneyViewButton":"m8nsEgbJ","finalDisplayButton":"ywLNPYRf","nextMobButton":"IG1SBYy0","backButton":"nQQLFdUW","furtherButton":"SdglSYuY","dialog":"cuHtN1Jq"};
    if(module.hot) {
      // 1717522987614
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  